import React from 'react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { toolbarMediaMessages } from '@atlaskit/editor-common/media';
import { TOOLBAR_BUTTON, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import AttachmentIcon from '@atlaskit/icon/core/migration/attachment--editor-attachment';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
var onClickMediaButton = function onClickMediaButton(showMediaPicker) {
  return function () {
    showMediaPicker();
    return true;
  };
};
var ToolbarMedia = function ToolbarMedia(_ref) {
  var isDisabled = _ref.isDisabled,
    isReducedSpacing = _ref.isReducedSpacing,
    intl = _ref.intl,
    api = _ref.api;
  var _useSharedPluginState = useSharedPluginState(api, ['media'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    mediaState = _useSharedPluginState.mediaState;
  var allowsUploadsSelector = useSharedPluginStateSelector(api, 'media.allowsUploads', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var showMediaPickerSelector = useSharedPluginStateSelector(api, 'media.showMediaPicker', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var allowsUploads = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? allowsUploadsSelector : mediaState === null || mediaState === void 0 ? void 0 : mediaState.allowsUploads;
  var showMediaPicker = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? showMediaPickerSelector : mediaState === null || mediaState === void 0 ? void 0 : mediaState.showMediaPicker;
  if (!allowsUploads || !showMediaPicker) {
    return null;
  }
  var toolbarMediaTitle = toolbarMediaMessages.toolbarMediaTitle;
  return /*#__PURE__*/React.createElement(ToolbarButton, {
    buttonId: TOOLBAR_BUTTON.MEDIA,
    onClick: onClickMediaButton(showMediaPicker),
    disabled: isDisabled,
    title: intl.formatMessage(toolbarMediaTitle),
    spacing: isReducedSpacing ? 'none' : 'default',
    iconBefore: /*#__PURE__*/React.createElement(AttachmentIcon, {
      label: intl.formatMessage(toolbarMediaTitle)
    })
  });
};
export default injectIntl(ToolbarMedia);